import { render, staticRenderFns } from "./PodcastEpisodes.vue?vue&type=template&id=3a54dc1b&scoped=true&"
import script from "./PodcastEpisodes.vue?vue&type=script&lang=js&"
export * from "./PodcastEpisodes.vue?vue&type=script&lang=js&"
import style0 from "./PodcastEpisodes.vue?vue&type=style&index=0&id=3a54dc1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a54dc1b",
  null
  
)

export default component.exports